import { Typography } from '@mui/material';
import * as React from 'react';

export const NewsPage: React.FunctionComponent = () => {
    return <Typography>News page: Work in progress</Typography>;
};
